module.exports = __webpack_public_path__ + "img/diseno.a6fd3744.png";